export default __webpack_public_path__ + "static/media/inner-zero-touches-production.39e622a1.svg";